<template>
  <div class="wrap">
    <Head />
    <div class="part1">
      <p class="tit">数字资产工具包</p>
      <p class="txt">安全便捷的加密数字资产管理工具</p>
      <!-- <div class="img">
        <img
          src="../../../assets/images/mobile/product/part1-bg.png"
          alt=""
        >
      </div> -->
      <div class="download">
        <a
          class="ios"
          href="https://testflight.apple.com/join/P3hprKuv"
          target="view_blank"
        >
          <i class="iconfont iconios-2"></i>
          <span>iOS下载</span>
        </a>
        <a
          class="android"
          href="https://toolserver.hwelltech.com/download/hwtool-last.apk"
        >
          <i class="iconfont iconandroid"></i>
          <span>Android下载</span>
        </a>
        <div class="android" @click="goChrome">
          <img
            src="../../../assets/images/pc/product/digitization/Chrome.png"
            alt=""
          />
          <span>Chrome Extension</span>
        </div>
      </div>
    </div>

    <div class="part2">
      <p class="tit">产品介绍</p>
      <div class="line">
        恒为数字资产工具包是一个安全便捷的加密数字资产管理工具，能够帮助用户管理区块链账户及账户内的数字资产。
      </div>
    </div>

    <div class="part4">
      <p class="tit">产品特性及优势</p>
      <div class="center">
        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/product/toolkit/part4-1.png"
              alt=""
            />
          </div>
          <div class="right">
            <p class="title">安全</p>
            <p class="text">区块链账户密钥本地存储，交易采用离线签名更加安全</p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/product/toolkit/part4-2.png"
              alt=""
            />
          </div>
          <div class="right">
            <p class="title">简单</p>
            <p class="text">操作界面简洁，可方便实现数字资产的交易和转移</p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/product/toolkit/part4-3.png"
              alt=""
            />
          </div>
          <div class="right">
            <p class="title">快捷</p>
            <p class="text">资产转账速度快，仅需3-5秒就能确认到账</p>
          </div>
        </div>

        <div class="card">
          <div class="left">
            <img
              src="../../../assets/images/mobile/product/toolkit/part4-4.png"
              alt=""
            />
          </div>
          <div class="right">
            <p class="title">真实</p>
            <p class="text">基于区块链技术，资产的转移和交易直接在链上进行</p>
          </div>
        </div>
      </div>
    </div>

    <div class="part5">
      <p class="tit">产品核心功能</p>
      <div class="content">
        <div class="card">
          <div class="img">
            <img
              src="../../../assets/images/mobile/product/toolkit/part5-1.png"
              alt=""
            />
          </div>
          <p>账户管理</p>
        </div>
        <div class="card">
          <div class="img">
            <img
              src="../../../assets/images/mobile/product/toolkit/part5-2.png"
              alt=""
            />
          </div>
          <p>资产管理</p>
        </div>
        <div class="card">
          <div class="img">
            <img
              src="../../../assets/images/mobile/product/toolkit/part5-3.png"
              alt=""
            />
          </div>
          <p>去中心化交易</p>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../../components/mobile/Head.vue";
import Foot from "../../../components/mobile/Foot.vue";
export default {
  data() {
    return {};
  },
  components: {
    Head,
    Foot,
  },
  created() {},
  methods: {
    /*跳转到ChromeExtension页*/
    goChrome() {
      this.$router.push({ name: "mobileChromeExtension" });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(550);
  background: linear-gradient(-30deg, #192F9C, #1185E9);
  position: relative;
  part1();
  padding-top: vw(60);

  .tit {
    margin-bottom: vw(25);
    hTit();
  }

  .txt {
    font-size: vw(24);
    line-height: vw(36);
    text-align: center;
    color: #fff;
  }

  .download {
    .ios, .android {
      margin: 0 auto;
      width: vw(430);
      height: vw(80);
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(255, 255, 255, 0.6);
      border-radius: vw(80);

      i, img {
        width: vw(48);
        font-size: vw(48);
        color: #fff;
      }

      span {
        display: inline-block;
        margin-left: vw(20);
        font-size: vw(28);
        color: #fff;
      }
    }

    .ios {
      margin-top: vw(40);
    }

    .android {
      margin-top: vw(40);
    }
  }

  .img {
    width: 100%;
    position: absolute;
    bottom: vw(50);
    text-align: center;

    img {
      width: vw(314);
      height: vw(350);
    }
  }
}

.part2 {
  part();
  background: #fff;

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .line {
    font-size: vw(28);
    color: #666666;
    line-height: vw(48);
    margin-bottom: vw(30);
    padding: 0 vw(30);
  }
}

.part3 {
  part();
  padding: vw(80) 0 vw(100);
  background: #fff;

  .tit {
    tit3();
    margin-bottom: vw(80);
  }

  .img {
    text-align: center;

    img {
      width: vw(690);
      height: vw(364);
    }
  }
}

.part4 {
  part();
  background: rgba(249, 249, 249, 1);

  .tit {
    tit3();
    margin-bottom: vw(30);
  }

  .center {
    width: 100%;

    .card {
      display: flex;
      width: vw(690);
      height: vw(231);
      margin: 0 auto vw(30);
      padding: vw(58) vw(45) 0 vw(40);
      background: #fff;
      box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

      .left {
        width: vw(179);
        margin-right: vw(37);

        img {
          width: 100%;
          height: auto;
        }
      }

      .right {
        flex: 1;

        .title {
          font-size: vw(32);
          line-height: vw(32);
          margin: vw(4) 0 vw(10);
          color: #444444;
        }

        .text {
          font-size: vw(24);
          color: #888;
          line-height: vw(36);
        }
      }
    }
  }
}

.part5 {
  part();
  background: #fff;
  padding: vw(80) vw(17) vw(50);

  .tit {
    tit3();
    margin-bottom: vw(50);
  }

  .content {
    display: flex;
    flex-wrap: wrap;

    .card {
      width: vw(170);
      height: vw(170);
      margin: 0 vw(33) vw(30);
      border-radius: vw(10);
      box-shadow: 0px 0px vw(10) 0px rgba(0, 0, 0, 0.1);

      .img {
        text-align: center;
        margin: vw(37) 0 vw(20px);

        img {
          width: vw(50);
          height: vw(50);
        }
      }

      p {
        font-size: vw(24);
        color: #444444;
        text-align: center;
        line-height: vw(24);
      }
    }
  }
}
</style>
